/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_UnauthorizedInputs */

const th_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กรุณาเข้าสู่ระบบแล้วลองใหม่อีกครั้ง`)
};

const en_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please sign in and try again.`)
};

const ja_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログインしてからもう一度お試しください。`)
};

const zh_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请登录后重试。`)
};

const es_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión e inténtalo de nuevo.`)
};

const pt_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre na sua conta e tente de novo.`)
};

const id_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silakan masuk lalu coba lagi.`)
};

const fr_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous et réessayez.`)
};

const tl_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakisign in at subukang muli.`)
};

const vi_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng đăng nhập rồi thử lại.`)
};

const ko_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인한 뒤 다시 시도해 주세요.`)
};

const de_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte melde dich an und versuche es erneut.`)
};

const ru_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите и попробуйте снова.`)
};

const tr_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lütfen giriş yapıp yeniden deneyin.`)
};

const it_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi e riprova.`)
};

const pl_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się i spróbuj ponownie.`)
};

const uk_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увійдіть і спробуйте ще раз.`)
};

const hi_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया साइन इन करके फिर कोशिश करें।`)
};

const ar_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجّل الدخول ثم أعد المحاولة.`)
};

const ms_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sila log masuk dan cuba lagi.`)
};

const bn_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অনুগ্রহ করে সাইন ইন করে আবার চেষ্টা করুন।`)
};

const zh_tw2_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請登入後再試一次。`)
};

const zh_hk2_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請登入後再試一次。`)
};

const ur_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`براہ کرم سائن اِن کر کے دوبارہ کوشش کریں۔`)
};

const fa_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لطفاً وارد شوید و دوباره تلاش کنید.`)
};

const sw_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tafadhali ingia kisha ujaribu tena.`)
};

const nl_err_unauthorized = /** @type {(inputs: Err_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in en probeer het opnieuw.`)
};

/**
* | output |
* | --- |
* | "Please sign in and try again." |
*
* @param {Err_UnauthorizedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_unauthorized = /** @type {((inputs?: Err_UnauthorizedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_UnauthorizedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_unauthorized(inputs)
	if (locale === "ja") return ja_err_unauthorized(inputs)
	if (locale === "zh") return zh_err_unauthorized(inputs)
	if (locale === "es") return es_err_unauthorized(inputs)
	if (locale === "pt") return pt_err_unauthorized(inputs)
	if (locale === "id") return id_err_unauthorized(inputs)
	if (locale === "fr") return fr_err_unauthorized(inputs)
	if (locale === "tl") return tl_err_unauthorized(inputs)
	if (locale === "vi") return vi_err_unauthorized(inputs)
	if (locale === "ko") return ko_err_unauthorized(inputs)
	if (locale === "de") return de_err_unauthorized(inputs)
	if (locale === "ru") return ru_err_unauthorized(inputs)
	if (locale === "tr") return tr_err_unauthorized(inputs)
	if (locale === "it") return it_err_unauthorized(inputs)
	if (locale === "pl") return pl_err_unauthorized(inputs)
	if (locale === "uk") return uk_err_unauthorized(inputs)
	if (locale === "hi") return hi_err_unauthorized(inputs)
	if (locale === "ar") return ar_err_unauthorized(inputs)
	if (locale === "ms") return ms_err_unauthorized(inputs)
	if (locale === "bn") return bn_err_unauthorized(inputs)
	if (locale === "zh-TW") return zh_tw2_err_unauthorized(inputs)
	if (locale === "zh-HK") return zh_hk2_err_unauthorized(inputs)
	if (locale === "ur") return ur_err_unauthorized(inputs)
	if (locale === "fa") return fa_err_unauthorized(inputs)
	if (locale === "sw") return sw_err_unauthorized(inputs)
	if (locale === "nl") return nl_err_unauthorized(inputs)
	return en_err_unauthorized(inputs)
});